export default "__VITE_ASSET__CiMeUBG6__"